module.exports = __webpack_public_path__ + "img/vampship.007c7219.webp";